import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{
  isColumn?: boolean;
  hasBorder?: boolean;
}>`
  display: flex;
  background: ${({ theme }) => theme.COLOR.WHITE};
  padding: 20px;

  ${({ isColumn }) =>
    isColumn &&
    css`
      flex-direction: column;
      gap: 20px 0;
    `}
`;

export const DateSection = styled.div`
  padding-right: 20px;
`;

export const TimeSection = styled.div`
  width: 180px;
  padding-left: 20px;
  border-left: 1px solid ${({ theme }) => theme.COLOR.GREY_05};
`;

export const DropdownSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  height: 78px;
  margin-bottom: 20px;
`;

export const DriverInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px 0;
`;

export const OptionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;
`;

export const Text = styled.p<{ color?: string }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ color, theme }) => (color ? color : theme.COLOR.GREY_02)};
`;
